<template>
  <el-container class="grid-layout">
    <!-- Page Header -->
    <el-header class="title" height="max-content">
      <h5 class="text-sc">
        <b>
          {{ title }}
        </b>
      </h5>
    </el-header>

    <!-- Page Body -->
    <el-main class="grid-layout">
      <div>
        <el-input
          v-model="search"
          type="text"
          placeholder="ค้นหาชื่อ-นามสกุล หรือ อีเมล"
          @keypress.enter.native="getNoticeList(search, 1, size)"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getNoticeList(search, 1, size)"
          >
          </el-button>
        </el-input>
        <p class="text-secondary">พบข้อมูล {{ total }} คน</p>
      </div>

      <div class="action">
        <el-button type="primary" @click="goto('LineNotifyAdd')">
          เพิ่มผู้ใช้งาน
        </el-button>
      </div>

      <!-- Empty List -->
      <el-empty v-if="items.length < 1" :image-size="200"> </el-empty>

      <!-- User List -->
      <div v-if="items.length > 0" class="list-item notice-list">
        <div
          v-for="(user, i) of items"
          :key="i"
          class="grid-layout item el-card"
          @click="goto('LineNotifyUser', { user })"
        >
          <el-avatar :size="80" shape="square">
            <b>
              {{ user.role_name }}
            </b>
          </el-avatar>
          <div>
            <b>
              {{ user.email }}
            </b>
            <br />
            <p class="text-secondary">
              {{ user.first_name }} {{ user.last_name }}
            </p>
          </div>
        </div>
      </div>

      <!-- List Pagination -->
      <el-pagination
        v-if="total > 0"
        :current-page.sync="current"
        :page-size="size"
        :total="total"
        class="text-center"
        layout="
          prev, pager, next
        "
        @current-change="(page) => (current = page)"
      />
    </el-main>

    <!-- Alert -->
    <el-dialog
      :title="alert.title"
      :visible.sync="alert.open"
      width="40%"
      top="0"
    >
      <span>
        {{ alert.message }}
      </span>

      <div slot="footer">
        <el-button type="info" @click="alert.open = false"> ปิด </el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
// LINE Notify Service
import { useCases } from "../LineNotifyService"

export default {
  name: "LineNotifyNotice",
  props: {
    width: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      title: "รายการผู้ใช้งาน",
      current: 1,
      items: [],
      search: "",
      size: 10,
      total: 0,
      alert: {
        open: false,
        title: "",
        message: "",
      },
    }
  },
  watch: {
    async current() {
      await this.getNoticeList()
    },
  },
  async created() {
    await this.getNoticeList()
  },
  methods: {
    goto(name, params) {
      this.$router.push({
        name,
        params,
      })
    },
    async getNoticeList() {
      // Request Notice Lisr
      const result = await useCases.noticeList(
        this.search,
        this.current,
        this.size,
      )

      // Fetch Result
      const { code, message, items, total } = result

      // Validate Result Code
      if (code === 20000) {
        // Notice Data
        this.items = items
        this.total = total
      } else {
        // Reset Data
        this.items = []
        this.total = 0

        // Error Alert
        this.alert = {
          open: true,
          title: "เกิดข้อผิดพลาด",
          message,
        }
      }
    },
  },
}
</script>

<style scoped>
@import url("../LineNotify.css");

.grid-layout.header {
  grid-template-columns: minmax(auto, 100%) auto;
}

.notice-list {
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.notice-list .item {
  grid-template-columns: max-content minmax(auto, 100%);
  align-items: center;
}

.action {
  text-align: right;
}

/* Mobile Size */
@media screen and (max-width: 768px) {
  .notice-list {
    grid-template-columns: 100%;
  }
}
</style>
